import { clsx } from "clsx";
import { PureComponent, type ReactElement } from "react";
import { TimeAgo } from "widgets";

import { RelativeUserLabel } from "@/modules/users/components/RelativeUserLabel.js";

import { pluralizeWord } from "../../app-utils/string.js";
import { type ParentType, type User } from "../../graphql.js";
import { Checkbox } from "../core/forms/Checkbox.js";
import ModifyParentTypeDialog from "./ModifyParentTypeDialog.js";

export interface IParentTypeItemProps {
  user: User;
  parentType: ParentType;
  isSelected: boolean;

  onItemSelectionChange: (parentType: ParentType, selected: boolean) => void;
  fetchFullParentTypeWithAttributes: (parentTypeId: number) => Promise<ParentType>;
}

interface IParentTypeItemState {
  showModifyParentTypeDialog?: boolean;
}

class ParentTypeItem extends PureComponent<IParentTypeItemProps, IParentTypeItemState> {
  constructor(props) {
    super(props);

    this.state = {
      showModifyParentTypeDialog: false,
    };
  }

  handleItemSelectionChange = (event: any): void => {
    this.props.onItemSelectionChange(this.props.parentType, event.target.checked);
  };

  handleModifyParentType = () => {
    this.setState({ showModifyParentTypeDialog: true });
  };

  render(): ReactElement {
    const { id, name, description, creator, created, attributeCount, sampleCount, sampleTypeCount } =
      this.props.parentType;

    return (
      <li
        className={clsx("saved-item", "clearfix", {
          "item-row-selected": this.props.isSelected,
        })}
        key={`sample-type-admin-${id}`}
      >
        <div className="item-checkbox-wrapper">
          <div className="item-checkbox checkbox check-default">
            <Checkbox
              id={`saved-item-checkbox-${id}`}
              checked={this.props.isSelected}
              onChange={this.handleItemSelectionChange}
            />
          </div>
        </div>

        <div className="item-desc-wrapper">
          <div className="admin-tools-item-title">
            <a onClick={this.handleModifyParentType} title="Modify this parent type">
              {name}
            </a>{" "}
            <span className="item-count">
              ({attributeCount} {pluralizeWord("attribute", attributeCount)})
            </span>{" "}
            <span className="item-updated">
              saved by <RelativeUserLabel user={creator} /> <TimeAgo dateTimeISO={created} />
            </span>
          </div>
          <p>{description}</p>
        </div>

        <div className="item-label-wrapper">
          <div className="list-item-label label-a">
            Used for {sampleTypeCount} sample {pluralizeWord("type", sampleTypeCount)}, {sampleCount}{" "}
            {pluralizeWord("sample", sampleCount)}
          </div>
        </div>

        {this.state.showModifyParentTypeDialog && (
          <ModifyParentTypeDialog
            title="Modify Parent Type"
            parentType={this.props.parentType}
            fetchFullParentTypeWithAttributes={this.props.fetchFullParentTypeWithAttributes}
            onApply={() => this.setState({ showModifyParentTypeDialog: false })}
            onClose={() => this.setState({ showModifyParentTypeDialog: false })}
          />
        )}
      </li>
    );
  }
}

export default ParentTypeItem;
